'use strict';

/**
 * Returns true if `a` is a string.
 *
 * @private
 */
function isString(a) {
  return typeof a === 'string';
}

exports.isString = isString;
